import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['copy'];

  connect() {
    console.log('copy connect', this.element);
  }

  copy(event) {
    const htmlContent = this.copyTarget.dataset.copyHtmlContents;
    const temp = document.createElement('div');
    temp.style.position = 'fixed';
    temp.style.left = '-9999px';
    temp.innerHTML = htmlContent;
    document.body.appendChild(temp);
    const plainText = temp.innerText;
    document.body.removeChild(temp);

    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([plainText], { type: 'text/plain' }),
        'text/html': new Blob([htmlContent], { type: 'text/html' }),
      }),
    ]);

    this.element.dispatchEvent(
      new CustomEvent('triggerPopup', {
        detail: {
          // The `detail` key will carry the payload for your event
          message: this.copyTarget.dataset.copyPopupMessage,
        },
        bubbles: true, // Necessary to make the event bubble to other controllers upstream in the DOM.
      }),
    );
    event.preventDefault();
  }
}
